var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimaryAttachmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999159 11.9471L10.1892 2.75715C11.315 1.63131 12.842 0.998813 14.4342 0.998813C16.0263 0.998813 17.5533 1.63131 18.6792 2.75715C19.805 3.88299 20.4375 5.40997 20.4375 7.00215C20.4375 8.59433 19.805 10.1213 18.6792 11.2472L9.48916 20.4371C8.7386 21.1877 7.72062 21.6094 6.65916 21.6094C5.5977 21.6094 4.57972 21.1877 3.82916 20.4371C3.0786 19.6866 2.65693 18.6686 2.65693 17.6071C2.65693 16.5457 3.0786 15.5277 3.82916 14.7771L13.0292 5.58715C13.4044 5.21187 13.9134 5.00104 14.4442 5.00104C14.9749 5.00104 15.4839 5.21187 15.8592 5.58715C16.2344 5.96243 16.4453 6.47142 16.4453 7.00215C16.4453 7.53288 16.2344 8.04187 15.8592 8.41715L7.36916 16.8971",
    stroke: "#038E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryAttachmentIcon);
export default __webpack_public_path__ + "static/media/primary-attachment-icon.809796ed.svg";
export { ForwardRef as ReactComponent };